<template>
  <!-- 住宿 -->
  <div :key="domKey">
    <div style="position:relative">
      <TopButtom v-bind:buttonlist="buttonlist" v-on:changeDataList="changeDataList"></TopButtom>
    </div>
    <div class="tabcpage" v-show="ifShowList">
      <div class="rowA" v-show="deviceId == 1">
        <div class="english">STAR HOTEL</div>
        <div class="chinese">星级酒店</div>
      </div>
      <div class="rowA" v-show="deviceId == 2">
        <div class="english">ECONOMY HOTEL</div>
        <div class="chinese">经济酒店</div>
      </div>
      <div class="rowB">
        <div class="body">
          <div class="line"></div>
          <div v-for="item in datalist" :key="item.key">
            <div style="display:flex;flex-direction:row" @click="seeInfo(item)">
              <div class="middleDiv">
                <img :src="item.icon" class="middleImg" v-if="item.icon != null" />
                <img src="@/assets/image/wys.png" class="middleImg" v-else />
              </div>
              <div style="display:flex;flex-direction:column">
                <div class="topTitle">{{ item.title }}</div>
                <div class="desc">{{ item.introduce }}</div>
              </div>
            </div>
            <div class="line" style="margin-top:1.3888vh"></div>
          </div>
          <div class="footer">
            <NewPagunation :nowCurrent="current" :total="total" :pageSize="pageSize" @getPage="getPage"></NewPagunation>
          </div>
        </div>
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
    <DetailsInfo :info="info" @closed="closed" v-show="!ifShowList"></DetailsInfo>
  </div>
</template>

<script>
import "@/css/listVertical.css";
import DetailsInfo from "./detailsInfo";
import NewPagunation from "@/components/common/NewPagunation.vue";
import TopButtom from "@/components/common/TopButtom.vue";
import { getOpenMenu, getOpenAddHits } from "@/api/common";
export default {
  name: "TabApage",
  components: { TopButtom, NewPagunation, DetailsInfo },
  data() {
    return {
      ifShowList: true,//是否显示列表
      info: {},
      domKey: '',
      current: 1,
      pageSize: 3,
      total: 0,
      datalist: [],
      buttonlist: [
        {
          id: 1,
          leftS: "left:1.5625vw",
          leftX: "left:1.458vw",
          title: "星级酒店",
          noCheckX: false
        },
        {
          id: 2,
          leftS: "left:10.5208vw",
          leftX: "left:10.4167vw",
          title: "经济酒店",
          noCheckX: true
        },
      ]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        this.buttonlist.forEach(element => {
          element.id == deviceId ? (element.noCheckX = false) : (element.noCheckX = true);
        });
        let timestamp = Date.parse(new Date())
        this.current = 1;
        this.domKey = timestamp
        if (deviceId == 1) {
          this.getHotelList1Function();
        } else if (deviceId == 2) {
          this.getHotelList2Function();
        } else if (deviceId == 3) {
          this.getHotelList3Function();
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    //切换标签
    changeDataList(type) {
      this.$store.commit("setTabPage", type);
      let name = "TabHotel";
      this.$emit("specialtyListFunction", name);
    },
    //详情
    async seeInfo(info) {
      if (info.status) {
        if (info.status === 1) {
          await getOpenAddHits(info.id);
          this.info = info;
          this.ifShowList = false;
        } else {
          window.open(info.brief)
        }
      } else {
        await getOpenAddHits(info.id);
        this.info = info;
        this.ifShowList = false;
      }

    },
    //星级
    async getHotelList1Function() {
      const { code, data } = await getOpenMenu(this.current, this.pageSize, 'hotel_star');
      if (code == 200) {
        this.datalist = data.records;
        let BASE_URL = this.Global
        this.datalist.forEach(element => {
          element.introduce != null ? element.introduce = element.introduce.slice(0, 176) + "....." : ''
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
          element.url != null ? (element.url = `${BASE_URL}${element.url}`) : "";
        });
        this.total = data.total;
      }
    },

    //经济酒店
    async getHotelList2Function() {
      const { code, data } = await getOpenMenu(this.current, this.pageSize, 'hotel_economy');
      if (code == 200) {
        this.datalist = data.records;
        let BASE_URL = this.Global
        this.datalist.forEach(element => {
          element.introduce != null ? element.introduce = element.introduce.slice(0, 176) + "....." : ''
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
          element.url != null ? (element.url = `${BASE_URL}${element.url}`) : "";
        });
        this.total = data.total;
      }
    },
    //特色名宿
    async getHotelList3Function() {
      const { code, data } = await getOpenMenu(this.current, this.pageSize, 'hotel_characteristic');
      if (code == 200) {
        this.datalist = data.records;
        let BASE_URL = this.Global
        this.datalist.forEach(element => {
          element.introduce != null ? element.introduce = element.introduce.slice(0, 176) + "....." : ''
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
          element.url != null ? (element.url = `${BASE_URL}${element.url}`) : "";
        });
        this.total = data.total;
      }
    },
    //分页
    getPage(current) {
      this.current = current;
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        this.getHotelList1Function();
      } else if (deviceId == 2) {
        this.getHotelList2Function();
      } else if (deviceId == 3) {
        this.getHotelList3Function();
      }
    },
    //返回
    closed() {
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        this.getHotelList1Function();
      } else if (deviceId == 2) {
        this.getHotelList2Function();
      } else if (deviceId == 3) {
        this.getHotelList3Function();
      };
      this.ifShowList = true;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/hotel/tabHotel.vue